import { render, staticRenderFns } from "./ProviderDescription.vue?vue&type=template&id=292494a2&"
import script from "./ProviderDescription.vue?vue&type=script&lang=ts&"
export * from "./ProviderDescription.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderDescription.vue?vue&type=style&index=0&id=292494a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports